
export const ErrorText = {
	required: 'Required',
	minLength: (val) => `Minimum of ${val} characters`,
	maxLength: (val) => `Maximum of ${val} characters`,
	password: 'Password must contain at least 1 letter and 1 number',
	passwordMatch: 'Passwords must match',
	emailMatch: 'Email addresses must match',
	phoneMatch: 'Phone numbers must match',
	email: 'Please input a valid email',
	phone: 'Please input a valid phone number',
	textOnly: 'Only text is allowed',
	numberOnly: 'Only numbers are allowed',
	verificationCode: 'Please enter your 6 digit verification code',
	confirm: 'Must type "confirm" ',
	emailOrPhone: 'Please input a valid email or phone number',
	team: 'Please invite at least one person',
	pageMaxImages: 'Maximum of 10 images allowed',
	pageContent: 'Please include text or an attachment',
	bookPage: 'Please add pages to the book'
};

export const FormText = {
	archive: 'Archive',
	delete: 'DELETE',
	proceed: 'Discard Changes',
	back: 'Keep Editing',
	cancel: 'Cancel',
	ok: 'OK',
	stay: 'Stay',
	leave: 'Leave',
};